import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {DecoderData} from '../model/decoder-data';

export interface DecoderRow {
  label: string;
  key: string;
  value: string;
  position: number;
}

@Component({
  selector: 'decoder-table',
  templateUrl: './decoder-table.component.html',
  styleUrls: ['./decoder-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class DecoderTableComponent {

  readonly decoderData = input.required<DecoderData>();
  readonly title = input<string>('');

  readonly rows = computed<DecoderRow[]>(() => {
    const data = this.decoderData() as unknown as Record<string, string>;
    if (!data) {
      return [];
    }
    const rows: DecoderRow[] = [{label: data['atrtxta'], key: data['key01'], value: data['atvtxta'], position: this.position(data, 1)}];
    for (let sequence = 1; sequence <= 11; sequence++) {
      const label = data['s' + this.pad(sequence) + 'txt'];
      if (!label) {
        break;
      }
      rows.push({
        label,
        key: data['key' + this.pad(sequence + 1)],
        value: data['txt' + this.pad(sequence)],
        position: this.position(data, sequence + 1),
      });
    }
    return rows.every(row => row.position > 0) ? rows.sort((a, b) => a.position - b.position) : rows;
  });

  private position(data: Record<string, unknown>, keyNumber: number): number {
    const value = Number(data['pos' + this.pad(keyNumber)]);
    return Number.isFinite(value) ? value : 0;
  }

  private pad(position: number): string {
    return position < 10 ? '0' + position : String(position);
  }

}
